module.exports = __webpack_public_path__ + "static/media/SVGmoneyControl.c711ebc5.webp";